import React from 'react';
import PropTypes from 'prop-types';
import { ConfirmationModal } from 'web-ui-components/lib/organisms/modals';
import withContent from '../../../containers/withContent';
import pageContent from './index.content';

export const ScheduledPaymentsModal = ({ isModalOpen, handleClose, handleConfirmClick, content }) => {
	const { title, body, dismissButtonLabel, confirmButtonLabel } = content;
	return (
		<ConfirmationModal
			titleText={title}
			onConfirm={handleConfirmClick}
			onClose={handleClose}
			isOpen={isModalOpen}
			dismissButtonText={dismissButtonLabel}
			confirmButtonText={confirmButtonLabel}
		>
			<div className="u-margin-bottom-2">
				{body.map((bodyText) => (
					<p>{bodyText}</p>
				))}
			</div>
		</ConfirmationModal>
	);
};

ScheduledPaymentsModal.defaultProps = {
	isModalOpen: false,
};

ScheduledPaymentsModal.propTypes = {
	isModalOpen: PropTypes.bool,
	handleClose: PropTypes.func.isRequired,
	handleConfirmClick: PropTypes.func.isRequired,
	content: PropTypes.shape({}).isRequired,
};

export default withContent({ content: pageContent })(ScheduledPaymentsModal);
